import { useState } from "react";
import { Bar } from "react-chartjs-2";
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";

const CarBarChart = ({ data = [] }) => {
    const [showData, setShowData] = useState(false);

    const labels = data.length ? data.map((item) => item.carName) : ["car1", "car2", "car3", "car4", "car5", "car6", "car7", "car8", "car9", "car10", "car11", "car12"];
    const values = data.length ? data.map((item) => item.count) : [25, 18, 30, 15, 22, 11, 28, 35, 10, 20, 14, 27];
    const days = data.length ? data.map((item) => item.days) : [25, 18, 30, 15, 22, 11, 28, 35, 10, 20, 14, 27];
    const maxValue = Math.max(...values);
    const options = {
        indexAxis: "y",
        responsive: true,
        maintainAspectRatio: false,
        elements: {
            bar: {
                borderWidth: 1,
                borderRadius: 4,
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            title: {
                display: false,
            },
            datalabels: {
                display: showData,
                anchor: "end",
                align: "right",
                color: "#000",
                font: {
                    weight: "bold",
                },
                formatter: (_, context) => {
                    return `${days[context.dataIndex]} Days`;
                },
                clip: false,
            },
        },
        scales: {
            x: {
                beginAtZero: true,
                max: maxValue + (maxValue * 0.2),
            },
            y: {
                ticks: {
                    autoSkip: false,
                },
            },
        },
    };

    const chartData = {
        labels,
        datasets: [
            {
                label: "Bookings",
                data: values,
                borderColor: "rgb(255, 99, 132)",
                backgroundColor: "rgba(255, 99, 132, 0.5)",
            },
        ],
    };

    return (
        <div className="car-bar-chart">
            <div className="d-flex justify-content-between align-items-center">
                <h3>Car Booking Count</h3>

                <button onClick={() => setShowData((prev) => !prev)} className="btn" >
                    {showData ? <FaRegEye /> : <FaRegEyeSlash />}
                </button>
            </div>

            <div className="car-bar-chart-scroll">
                <div
                    className="car-bar-chart-inner"
                    style={{
                        height: `${Math.max(labels.length * 45, 400)}px`,
                    }}
                >
                    <Bar data={chartData} options={options} />
                </div>
            </div>
        </div>
    );
};

export default CarBarChart;